import { c as _c } from "react/compiler-runtime";
import { Form } from '@onefootprint/ui';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import useTenantScopeOptions from './hooks/use-tenant-scope-options';
const GrantEditRightsForm = () => {
  const $ = _c(41);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "components.privateLayout.assumeBanner.grantEditRightsDialog"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const scopeOptions = useTenantScopeOptions();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      "decrypt permissions": "Decrypt",
      "basic permissions": "",
      "compliance permissions": "",
      "proxy permissions": ""
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const permissionPrefixes = t1;
  let t2;
  if ($[2] !== scopeOptions.options) {
    t2 = () => scopeOptions.options.flatMap(optionGroup => {
      const prefix = permissionPrefixes[optionGroup.label.toLowerCase()] || "";
      return optionGroup.options.map(option => ({
        label: prefix ? `${prefix} ${option.label.toLowerCase()}` : capitalize(option.label),
        value: option.value
      }));
    });
    $[2] = scopeOptions.options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getFormattedOptions = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t(_temp);
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t) {
    t4 = t(_temp2);
    $[6] = t;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== getFormattedOptions) {
    t5 = getFormattedOptions();
    $[8] = getFormattedOptions;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t) {
    t6 = t(_temp3);
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <Form.MultiSelect name="scopes" label={t3} placeholder={t4} options={t5} hint={t6} />;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t) {
    t8 = t(_temp4);
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t) {
    t9 = t(_temp5);
    $[19] = t;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  if ($[21] !== t) {
    t10 = t(_temp6);
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t10 || $[24] !== t8 || $[25] !== t9) {
    t11 = <Form.Input size="compact" type="number" name="duration" label={t8} placeholder={t9} hint={t10} />;
    $[23] = t10;
    $[24] = t8;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t) {
    t12 = t(_temp7);
    $[27] = t;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t(_temp8);
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t) {
    t14 = t(_temp9);
    $[31] = t;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t12 || $[34] !== t13 || $[35] !== t14) {
    t15 = <Form.Textarea name="reason" label={t12} placeholder={t13} hint={t14} />;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  let t16;
  if ($[37] !== t11 || $[38] !== t15 || $[39] !== t7) {
    t16 = <div className="flex flex-col gap-5">{t7}{t11}{t15}</div>;
    $[37] = t11;
    $[38] = t15;
    $[39] = t7;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  return t16;
};
export default GrantEditRightsForm;
function _temp($) {
  return $.scopes.label;
}
function _temp2($_0) {
  return $_0.scopes.placeholder;
}
function _temp3($_1) {
  return $_1.scopes.hint;
}
function _temp4($_2) {
  return $_2.duration.label;
}
function _temp5($_3) {
  return $_3.duration.placeholder;
}
function _temp6($_4) {
  return $_4.duration.hint;
}
function _temp7($_5) {
  return $_5.reason.label;
}
function _temp8($_6) {
  return $_6.reason.placeholder;
}
function _temp9($_7) {
  return $_7.reason.hint;
}